<template>
  <b-overlay
    :show="isLoading"
    spinner-type="border"
    variant="light"
    spinner-variant="primary"
    spinner-small
    opacity="1"
    rounded>
    <div class="d-flex align-items-center justify-content-md-end">
      <i
        v-if="resellerCapacity(item, param).status !== 'normal'"
        class="fas fa-exclamation-triangle fa-xs mr-1"
        :class="resellerCapacity(item, param).className" />
      <span
        :class="resellerCapacity(item, param).className"
        class="font-weight-bold">
        {{ item[param].total | commaValue }}
      </span>
      <span class="mx-1">/</span>
      <span>{{ item[param].limit | commaValue }}</span>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import { commaValue } from '@/core/filters'

export default {
  name: 'ResellerCapacity',
  filters: {
    commaValue,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    param: {
      type: String,
      required: true,
      default: () => '',
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  computed: {
    ...mapGetters(['resellerCapacity'])
  },
}
</script>
